import purl from "./purl";
import toast from "./toast";
import dom from "./dom";
import modal from "./modal";

export default {
  purl,
  toast,
  dom,
  modal
};
